export const emptyItem = {
  price_id: 0,
  product_name: "None",
  price: 0,
  savings_amount: 0,
};
